import React from 'react';
import SidebarData from 'src/components/SidebarData';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItemText from '@mui/material/ListItemText';
import { useSelector } from 'react-redux';
import MenuIcon from '@mui/icons-material/Menu';
import logo from 'src/Images/shreeDurga.png';
import { NavLink } from 'react-router-dom';
import {
  DrawerHeader,
  StyledListItemButtonMobile,
  StyledListItemIconMobile,
  StyledListItem,
} from 'src/components/Layout/SidebarStyles';

function MobileSidebar() {
  const [openSidebar, setOpenSidebar] = React.useState(false);
  const authReducer = useSelector((state) => state.AuthReducer);
  const tenantName = authReducer.userData.tenant.name;

  const filteredSidebarData = SidebarData();

  const toggleMobileSidebar = (open) => () => {
    setOpenSidebar(open);
  };

  return (
    <div className="div-flex-row cg-10 div-align-center">
      <MenuIcon onClick={toggleMobileSidebar(true)} className="text-white" />
      <span className="text-xxl text-semi-bold text-white">{tenantName}</span>
      <Drawer
        anchor="left"
        open={Boolean(openSidebar)}
        onClose={toggleMobileSidebar(false)}
        id="drawerMobileView"
      >
        <Box
          onClick={toggleMobileSidebar(false)}
          onKeyDown={toggleMobileSidebar(false)}
        >
          <DrawerHeader className="sidebar-header">
            <img src={logo} height={30} width={30} alt="expound-logo" />
          </DrawerHeader>
          <List>
            {filteredSidebarData.map((text) => (
              <StyledListItem key={text.id} disablePadding>
                <NavLink to={text.url} className="navlink-button">
                  <StyledListItemButtonMobile>
                    <StyledListItemIconMobile>
                      {text.icon}
                    </StyledListItemIconMobile>
                    <ListItemText primary={text.name} />
                  </StyledListItemButtonMobile>
                </NavLink>
              </StyledListItem>
            ))}
          </List>
        </Box>
      </Drawer>
    </div>
  );
}

export default MobileSidebar;
